export const POWDERY_MODEL = "artichoke-powdery";
export const DOWNY_MODEL = "artichoke-downy";
export const MELCAST_MODEL = "melcast";

// Presentation reference only: the backend action remains authoritative.
export const PROVISIONAL_POWDERY_THRESHOLD = 7;
export const RISK_RECOVERY_CONCURRENCY = 3;

export const DISEASE_RISK_MODELS = {
  [POWDERY_MODEL]: { label: "Oidio del carciofo" },
  [DOWNY_MODEL]: { label: "Peronospora del carciofo" },
  [MELCAST_MODEL]: { label: "Malattie fungine · MELCAST" },
};

export const DISEASE_RISK_CROPS = [
  { aliases: ["carciofo", "carciofi", "artichoke"], models: [POWDERY_MODEL, DOWNY_MODEL] },
  { aliases: ["melone", "meloni", "muskmelon"], models: [MELCAST_MODEL], melonType: "muskmelon" },
  { aliases: ["anguria", "angurie", "cocomero", "cocomeri", "watermelon"], models: [MELCAST_MODEL], melonType: "watermelon" },
];
